const URL_PDF = 'https://www.openbank.pt/assets/static/pt/pdf/';
const LEGAL_INFORMATION = URL_PDF + 'footer/Legal_information_PT.pdf';
const WEALTH_RATE = URL_PDF + 'Investments/Wealth_rate_PT_2.pdf';

const generatePdf = urlsPdfs => {
    return [LEGAL_INFORMATION, ...urlsPdfs, WEALTH_RATE];
};

export default {
    generatePdf,
};
